var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15174",
    "data-name": "Group 15174",
    transform: "translate(-1474 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1995",
    "data-name": "Rectangle 1995",
    width: 45,
    height: 45,
    transform: "translate(1474 99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "google-docs",
    transform: "translate(1422 104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7945",
    "data-name": "Path 7945",
    d: "M64.089,35.148H84.684a3.093,3.093,0,0,0,3.089-3.089V10.3H80.565a3.093,3.093,0,0,1-3.089-3.089V0H64.089A3.093,3.093,0,0,0,61,3.089v28.97A3.093,3.093,0,0,0,64.089,35.148Zm4.119-20.663H80.565a1.03,1.03,0,0,1,0,2.059H68.208a1.03,1.03,0,1,1,0-2.059Zm0,4.119H80.565a1.03,1.03,0,0,1,0,2.059H68.208a1.03,1.03,0,1,1,0-2.059Zm0,4.119H80.565a1.03,1.03,0,1,1,0,2.059H68.208a1.03,1.03,0,1,1,0-2.059Zm0,4.119h8.238a1.03,1.03,0,1,1,0,2.059H68.208a1.03,1.03,0,1,1,0-2.059Z",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7946",
    "data-name": "Path 7946",
    d: "M332.03,16.424h6.6L331,8.789v6.6A1.03,1.03,0,0,0,332.03,16.424Z",
    transform: "translate(-251.465 -8.186)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon1);
export default __webpack_public_path__ + "static/media/head-icon1.7d4757814aa6e121e66aaa9b79248b19.svg";
export { ForwardRef as ReactComponent };